module.exports = __webpack_public_path__ + "img/wallet-right-gray-arrow.aa8115de.svg";